import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-good-day',
  templateUrl: './good-day.component.html',
  styleUrls: ['./good-day.component.scss'],
})
export class GoodDayComponent {
  @Input() user: { name?: string } | null = null;
}
